<template lang="pug">
b-modal#editProviderFeaturedGame.siteeditor-providergame(
  ref="editProviderFeaturedGame"
  :title="$t('ui.combine.edit_provider_featured_game')"
  centered
  no-fade
  no-close-on-backdrop
  size="xl-siteeditor-providergame"
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    div.row.mb-2
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.provider_code')" disabled).mb-0
          DebounceInput(
            size="sm"
            ref="provider_code"
            required
            type="text"
            :dirty="$v.provider_code.$dirty"
            :error="$v.provider_code.$error"
            v-model.trim.lazy="$v.provider_code.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.provider_code" :name="$t('ui.provider_code')")
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.provider_name')" disabled).mb-0
          DebounceInput(
            size="sm"
            ref="provider_name"
            required
            type="text"
            :dirty="$v.provider_name.$dirty"
            :error="$v.provider_name.$error"
            v-model.trim.lazy="$v.provider_name.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.provider_name" :name="$t('ui.provider_name')")
      .col-sm-12.col-md-12.col-lg-12
        .alert.alert-warning.p-1.mb-2.w-100 {{ $t('message.tooltips_sequence') }}
    div.row
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.game_list')").mb-3
          div.row.mb-3.animated.fadeIn
            div.col
              .clusterize-scroll.table-responsive(style="max-height: 63vh")
                table.table.table-sm.table-bordered.table-striped.mb-0.table-align-middle
                  thead.thead-dark
                    tr
                      th.text-center(width="10%" v-if="isEditProviderGameAccess")
                        span #
                      th(width="40%")
                        span(:title="$t('ui.game_id')") {{ $t("ui.game_id") }}
                      th(width="50%")
                        span(:title="$t('ui.game_name')") {{ $t("ui.game_name") }}
                  tbody.clusterize-content
                    tr(v-if="filterGameList.length == 0")
                      td(colspan="3").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in filterGameList")
                      td.actions.text-center(v-if="isEditProviderGameAccess")
                        span
                          a.fa.fa-plus.text-success(href="#" @click="onAdd(item)" :title="$t('ui.add')")
                      td
                        span(:title="item.game_code") {{ item.game_code }}
                      td
                        span(:title="item.game_name") {{ item.game_name }}
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.featured_list')").mb-3
          div.row.mb-3.animated.fadeIn
            div.col
              .clusterize-scroll.table-responsive(style="max-height: 63vh")
                table.table.table-sm.table-bordered.table-striped.mb-0.table-align-middle
                  thead.thead-dark
                    tr
                      th.text-center(width="10%" v-if="isEditProviderGameAccess")
                        span #
                      th(width="20%")
                        span(:title="$t('ui.game_id')") {{ $t("ui.game_id") }}
                      th(width="20%")
                        span(:title="$t('ui.game_name')") {{ $t("ui.game_name") }}
                      th(width="20%")
                        span(:title="$t('ui.game_provider')") {{ $t("ui.game_provider") }}
                      th(width="20%")
                        span {{ $t('ui.sequence') }}
                  tbody
                    tr(v-if="filterFeaturedList.length == 0")
                      td(colspan="5").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in filterFeaturedList")
                      td.actions.text-center(v-if="isEditProviderGameAccess")
                        span
                          a.fa.fa-trash.text-danger(href="#" @click="onRemove(item)" :title="$t('ui.remove')")
                      td
                        span(:title="item.game_code") {{ item.game_code }}
                      td
                        span(:title="item.game_name") {{ item.game_name }}
                      td
                        span(:title="item.provider_code") {{ item.provider_code }}
                      td
                        b-form-select.text-center(v-model="item.seq" @change="changedSeq(item, $event)" size="sm" :disabled="!isEditProviderGameAccess")
                          option(value=0 disabled) 0
                          option(v-for="index in filterFeaturedListLength" :key="index") {{ index }}
                          option(v-if="filterFeaturedListLength < 100" :key="100") 100
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, alphaNum } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      featuredList: [],
      providerGameList: [],
      provider_code: '',
      provider_name: '',
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      gameListFilterBy: "name",
      gameListSearch: "",
      offListFilterBy: "name",
      offListSearch: "",
      mapName: false,
      searchType: null,
      currentPage: 1,
      totalRow: 0,
      maxSeq: 0
    };
  },
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    filterGameListLength() {
      if (this.filterGameList) {
        return this.filterGameList.length;
      } else {
        return 0;
      }
    },
    filterFeaturedListLength() {
      if (this.filterFeaturedList) {
        if(this.maxSeq > this.filterFeaturedList.length) {
          return this.maxSeq;
        } else {
          return this.filterFeaturedList.length;
        }
      } else {
        return 0;
      }
    },
    filterGameList() {
      var freeList = this.providerGameList;
      var groupList = this.featuredList;
      var list = [];
      if(freeList == null) return list

      for(var i = 0; i < freeList.length; i++) {
        var temp = groupList.filter(item => {
          return item.game_code == freeList[i].game_code;
        })

        if (temp.length == 0) {
          list.push(freeList[i]);
        }
      }

      return list;
    },
    filterFeaturedList() {
      var oList = this.featuredList;
      var pList = this.providerGameList;
      if(pList == null) return []

      for(var i = 0; i < oList.length; i++) {
        var obj = pList.filter(item => { return item.game_code == oList[i].game_code });
        if (obj.length != 0) {
          oList[i].game_name = obj[0].game_name;

        }
      }

      return oList;
    },
    
    isEditProviderGameAccess() {
      return this.$helpers.showActionButton("e_providerfeaturedgame");
    }
  },
  validations: {
    provider_code: {
      required
    },
    provider_name: {
      required,
      alphaNum
    },
  },
  methods: {
    changedSeq: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_provider_game_seq_confirm", { mode: item.game_code + ' - ' + item.game_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmSeq(item, eventStatus);
          } else {
            this.getProviderFeaturedGameList();
          }
        });
    },
    confirmSeq: function(item, seq) {
      let url = config.providerFeaturedGameUpdateSeqUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        provider_code: item.provider_code,
        game_code: item.game_code,
        seq: seq
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getProviderFeaturedGameList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getProviderFeaturedGameList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    onAdd: function(e) {
      let url = config.providerFeaturedGameAddUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        provider_code: this.item.provider_code,
        game_code: e.game_code,
        game_name: e.game_name,
        game_type: this.item.category,
        img_url: e.game_image
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getProviderFeaturedGameList();
                this.getGameList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    onRemove: function(e) {
      let url = config.providerFeaturedGameRemoveUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        provider_code: e.provider_code,
        game_code: e.game_code,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getProviderFeaturedGameList();
                this.getGameList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getProviderFeaturedGameList: function(isSearch) {
      if (isSearch) this.currentPage = 1;

      let url = config.providerFeaturedGameListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        game_type: this.searchType,
        provider_code: this.item.provider_code,
        page_number: this.currentPage,
        page_size: -1,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.featuredList = response.data.dt;
                this.totalRow = this.featuredList.length > 0 ? this.featuredList[0].totalrows : 0;
                // this.getGameList();
                if(this.featuredList.length > 0) {
                  // Filter out objects with seq < 100, then find the max seq value
                  const maxSeq = this.featuredList
                      .filter(item => item.seq < 100) // Keep only items with seq < 100
                      .reduce((max, item) => Math.max(max, item.seq), -Infinity); // Find the maximum seq

                  this.maxSeq = maxSeq;
                } else {
                  this.maxSeq = 0;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getGameList: function() {
      let url = config.getGameList["oneUrl"];
      var json = {
        platform: this.provider_code.trim().toUpperCase(),
        gametype: this.item.category
      };

      if(this.item.aggregator != null) {
        json.aggregator = this.item.aggregator
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.status == "string" ? response.status == "200" : response.status == 200;
              this.feedback.status = response.statusText;

              if (this.feedback.success == true) {
                this.providerGameList = response.data.game;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.provider_code = this.item.provider_code;
      this.provider_name = this.item.provider_name;
      this.featuredList = [];
      this.providerGameList = [];
      this.searchType = null;
      this.getProviderFeaturedGameList();
      this.getGameList();
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getProviderFeaturedGameList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getProviderFeaturedGameList();
    },
  }
};
</script>
